<template>
  <div class="space-between-y">

    <el-alert title="审核通过" type="success" v-if="vo.examine === 'APPROVED'"
              description="审核通过，教师可以对服务自行进行发布"></el-alert>
    <el-alert show-icon title="审核驳回" type="error" v-if="vo.examine === 'REJECTED'" :description=" vo.examineErrMsg">
    </el-alert>
    <el-alert show-icon title="未审核" type="warning" v-if="vo.examine === 'PENDING'"
              description="未审核期间，教师的服务发布受限"></el-alert>

    <info :infos="[
        {label:'ID',value:vo.id},
        {label:'标题',value:vo.name},
        {label:'描述',value:vo.desc},
        {label:'价格',value:vo.price},
        {label:'定价单位',value:vo.unit},
        {label:'教师姓名',value:vo.teacherName},
        {label:'审核状态',value:vo.examine}
    ]"></info>

    <div v-if="vo.rich !== null" v-html="vo.rich"></div>

    <teacher-service-tag-edit @updated="getData" :key="vo.tagGroups?.length" :id="vo.id" :tag-groups="vo.tagGroups"></teacher-service-tag-edit>

    <el-divider></el-divider>

    <div class="items imgs">
      <cloud-img :border-radius="6" v-for="(url,index) in vo.imgs" :url="url" :key="index" :img-height="120"
                 :img-width="120"></cloud-img>
    </div>

  </div>
</template>

<script>
import {miuTeacherService} from "@/api/miu/teacherService";
import Info from "@/components/system/Info.vue";
import CloudImgs from "@/components/base/layout/img/CloudImgs.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import TeacherServiceTagEdit from "@/components/miu/TeacherServiceTagEdit.vue";

export default {
  name: 'TeacherServiceDetail',
  components: {
    TeacherServiceTagEdit,
    CloudImg,
    CloudImgs,
    Info
  },
  props: {
    id: Number
  },

  data() {
    return {
      vo: {},
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      miuTeacherService.detail(this.id).then(res => {
        console.log("miuTeacherService.detail(this.id):");
        this.vo = res.data;
        console.log(this.vo);
      })
    },
  },


}
</script>

<style scoped>

.items {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  gap: 12px;
}

.imgs {
  gap: 6px;
}

</style>
